import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import Footer from "./Footer";

const PHONE_DISPLAY = "01 84 80 46 86";
const PHONE_TEL = "tel:+33184804686";

const NAV = [
    { to: "/", label: "Accueil" },
    { to: "/reparateur-lave-linge-paris", label: "Lave-linge" },
    { to: "/reparateur-frigo-paris", label: "Frigo" },
    { to: "/reparateur-lave-vaisselle-paris", label: "Lave-vaisselle" },
    { to: "/zones-intervention", label: "Zones" },
    { to: "/tarifs", label: "Tarifs" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
];

export default function Layout({ children }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="App">
            {/* Skip link for accessibility & SEO */}
            <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-[var(--navy)] focus:text-[var(--cream)] focus:px-3 focus:py-1.5 focus:rounded">
                Aller au contenu principal
            </a>

            <header className="sticky top-0 z-40 bg-[var(--cream)]/85 backdrop-blur border-b border-[var(--line)]">
                <div className="max-w-7xl mx-auto px-5 lg:px-10 h-16 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2.5" data-testid="logo-home-link">
                        <span className="w-9 h-9 rounded-xl bg-[var(--navy)] grid place-items-center text-[var(--amber)] font-extrabold text-lg">E</span>
                        <span className="heading text-lg font-extrabold tracking-tight">Electrocase</span>
                    </Link>

                    <nav className="hidden lg:flex items-center gap-7" aria-label="Navigation principale">
                        {NAV.slice(1).map((n) => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                className={({ isActive }) =>
                                    `text-sm font-medium link-underline ${isActive ? "text-[var(--navy)]" : "text-[var(--ink-soft)] hover:text-[var(--navy)]"}`
                                }
                                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                {n.label}
                            </NavLink>
                        ))}
                    </nav>

                    <div className="flex items-center gap-2">
                        <a
                            href={PHONE_TEL}
                            className="phone-pill hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold"
                            data-testid="header-phone-cta"
                        >
                            <i className="fa-solid fa-phone-volume" />
                            <span>{PHONE_DISPLAY}</span>
                        </a>
                        <button
                            className="lg:hidden w-10 h-10 grid place-items-center rounded-md border border-[var(--line)]"
                            aria-label="Ouvrir le menu"
                            onClick={() => setOpen(!open)}
                            data-testid="mobile-menu-toggle"
                        >
                            <i className={`fa-solid ${open ? "fa-xmark" : "fa-bars"} text-[var(--navy)]`} />
                        </button>
                    </div>
                </div>

                {open && (
                    <div className="lg:hidden border-t border-[var(--line)] bg-[var(--cream)]">
                        <nav className="max-w-7xl mx-auto px-5 py-4 grid gap-2" aria-label="Menu mobile">
                            {NAV.map((n) => (
                                <NavLink
                                    key={n.to}
                                    to={n.to}
                                    onClick={() => setOpen(false)}
                                    className={({ isActive }) =>
                                        `px-2 py-2 rounded-md text-base ${isActive ? "bg-[var(--paper)] text-[var(--navy)] font-semibold" : "text-[var(--ink-soft)]"}`
                                    }
                                    data-testid={`mnav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                >
                                    {n.label}
                                </NavLink>
                            ))}
                            <a href={PHONE_TEL} className="mt-2 phone-pill inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full font-semibold" data-testid="mobile-phone-cta">
                                <i className="fa-solid fa-phone-volume" /> {PHONE_DISPLAY}
                            </a>
                        </nav>
                    </div>
                )}
            </header>

            <main id="main">{children}</main>

            <Footer />

            {/* Floating phone CTA mobile */}
            <a
                href={PHONE_TEL}
                className="sm:hidden fixed bottom-4 left-4 z-50 phone-pill inline-flex items-center gap-2 px-4 py-3 rounded-full font-semibold shadow-xl"
                data-testid="floating-phone-cta"
            >
                <i className="fa-solid fa-phone-volume" /> Appeler
            </a>
        </div>
    );
}

export { PHONE_DISPLAY, PHONE_TEL };
